import { render, staticRenderFns } from "./highChart.vue?vue&type=template&id=84fbbdae&lang=pug&"
import script from "./highChart.vue?vue&type=script&lang=js&"
export * from "./highChart.vue?vue&type=script&lang=js&"
import style0 from "./highChart.vue?vue&type=style&index=0&id=84fbbdae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports